/* eslint-disable no-restricted-imports */
import Translate from '~/client/shared/i18n/Translate';
import GameDetailsContainer from './GameDetailsContainer';

type Props = { translateId: string };

const MobileGameDetailsRow: FC<Props> = ({ translateId, children }) => (
  <GameDetailsContainer>
    <p className="text-xs text-trunks">
      <Translate id={translateId} />
    </p>
    <p className="text-xs font-semibold text-bulma">{children}</p>
  </GameDetailsContainer>
);

export default MobileGameDetailsRow;
